var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5d626c",
    d: "M31.167 28.446a5.131 5.131 0 0 0-3.484 1.392l-12.676-7.5a6.009 6.009 0 0 0 .16-1.265 6.009 6.009 0 0 0-.16-1.265L27.54 12.38a5.264 5.264 0 0 0 3.627 1.464A5.371 5.371 0 0 0 36.5 8.422a5.334 5.334 0 1 0-10.667 0 6.009 6.009 0 0 0 .16 1.265L13.46 17.114a5.264 5.264 0 0 0-3.627-1.464 5.422 5.422 0 0 0 0 10.843 5.264 5.264 0 0 0 3.627-1.463l12.658 7.518a5.179 5.179 0 0 0-.142 1.175 5.192 5.192 0 1 0 5.191-5.277z",
    transform: "translate(-4.5 -3)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.f0a0e7ac09c1f62833b3484c8a03444d.svg";
export { ForwardRef as ReactComponent };